const hotelOptions = [
    { value: 'Veranda Pointe aux Biches Hotel', idBooking: '74764', label: 'Veranda Pointe aux Biches Hotel' },
    { value: 'Veranda Paul et Virginie Hotel', idBooking: '74756', label: 'Veranda Paul et Virginie Hotel' },
    { value: 'Veranda Grand Baie Hotel', idBooking: '74760', label: 'Veranda Grand Baie Hotel' },
    { value: 'Veranda Tamarin Hotel', idBooking: '106630', label: 'Veranda Tamarin Hotel' },
    { value: 'Veranda Palmar Beach Hotel', idBooking: '74762', label: 'Veranda Palmar Beach Hotel' },
];

export {
    hotelOptions
}